export const getIsLoaded = state => state.isLoaded
